import type Highcharts from "highcharts";

import { pixelDistanceBetweenPoints } from "@/lib/graph/pixel-point-distance";

/** Matches line-graph marker culling: marker radius default × 2.5 */
export const MIN_PIXEL_DISTANCE_MARKER_FACTOR = 2.5;

export function minPixelDistanceFromMarkerRadius(markerRadius: number): number {
  return markerRadius * MIN_PIXEL_DISTANCE_MARKER_FACTOR;
}

/**
 * Greedy pass in data order: keep a point visible iff it is farther than
 * `minPixelDistance` from every previously kept point (in pixel space).
 */
export function greedyCullVisibleFlags(
  points: Highcharts.Point[],
  chart: Highcharts.Chart,
  minPixelDistance: number,
): boolean[] {
  const visible: boolean[] = [];
  const kept: Highcharts.Point[] = [];

  points.forEach((point) => {
    const ok = kept.every((prev) => {
      const d = pixelDistanceBetweenPoints(chart, point, prev);
      if (d === undefined) return true;
      return d > minPixelDistance;
    });
    visible.push(ok);
    if (ok) {
      kept.push(point);
    }
  });

  return visible;
}
